import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c4b1c72c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "PriceCalculateImageContainer flex items-center"
};
const _hoisted_2 = {
  class: "mr6"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://cdn.waityou.online/168a85cd-0da5-8223-31b5-8c4b761dfd78.svg",
  style: {
    "width": "30px"
  }
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "boldFont opd6 ft20"
}, "=", -1));
const _hoisted_5 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PriceCalculateLoad = _resolveComponent("PriceCalculateLoad");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.right ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("span", _hoisted_2, _toDisplayString($data.left), 1), _hoisted_3, _hoisted_4, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.right, (l, li) => {
    return _openBlock(), _createBlock(_component_PriceCalculateLoad, {
      key: `right_${li}`,
      data: l
    }, null, 8, ["data"]);
  }), 128))], 64)) : (_openBlock(), _createElementBlock("span", _hoisted_5, "其他"))]);
}